module.exports = __webpack_public_path__ + "img/thumbnail3d.b8e5fd73.jpg";